import { QueryTypes } from 'services/api/data'

import { ROUTE_URLS } from 'router/routes'

import { LanguagesType, shortLanguages } from 'shared/locale'

import GameCatalogConverter from './providersData/GameCatalog/GameCatalogConverter'
import {
  DIGITAIN_PROVIDERS_WHITE_LIST,
  getSoftgamingFilterProviders,
} from './providersData/GameCatalog/GameCatalogUtils'
import { getPureGameId } from './providersData/GameCatalog/uniqGameId'
import OutcomeConverter from './providersData/Outcome/OutcomeConverter'
import SoftwissConverter from './providersData/Softswiss/SoftwissConverter'
import { ISlotProvidersConfiguration, Providers } from './types/configuration'
import { IGetBodyParams } from './types/interfaces/Slots/GameCatalog'
import { ISlotViewItem } from './types/interfaces/Slots/Slots'
import { renameProducerForKeltgamesStart } from './utils/helpers/helpers'

type ConvertorsTypes = OutcomeConverter | SoftwissConverter | GameCatalogConverter

const OutcomeConverterClass = new OutcomeConverter()
const SoftwissConvterClass = new SoftwissConverter()
const GameCatalogConverterClass = new GameCatalogConverter()

export const slotProvidersConfiguration: ISlotProvidersConfiguration<ConvertorsTypes> = {
  [Providers.SOFTSWISS]: {
    gameListUrl: 'api/integrations/softswiss/v2/games/',
    converter: SoftwissConvterClass,
    multiProvider: true,
    sessionUrlData: {
      url: 'api/integrations/softswiss/createsession/',
      demoUrl: 'api/integrations/softswiss/demostart/',
      method: QueryTypes.POST,
      getBody: params => ({
        game: params.gameId,
        return_url: `${location.origin}${ROUTE_URLS.SLOTS('casino')}`,
        client_type: params.isDesktop ? 'desktop' : 'mobile',
      }),
      converter: SoftwissConvterClass.convertGameUrl,
    },
  },

  [Providers.OUTCOME]: {
    // authRequired: true,
    gameListUrl: 'api/integrations/outcome/v2/gamelist/',
    converter: OutcomeConverterClass,
    sessionUrlData: {
      url: 'api/integrations/cf73bd58/login/',
      demoUrl: 'api/integrations/cf73bd58/login/demo/',
      freeSpinUrl: 'api/integrations/cf73bd58/login/freespin/',
      freeSpinInfoUrl: 'api/users/freespin-session/',
      method: QueryTypes.POST,
      getBody: params => ({
        GameId: params.gameId,
      }),
      converter: OutcomeConverterClass.convertGameUrl,
      freeSpinInfoConverter: OutcomeConverterClass.convertFreeSpinInfo,
      getHeaders: () => ({ 'Content-Type': 'application/json' }),
    },
    multiProvider: true,
  },

  [Providers.SOFTGAMING]: {
    gameListUrl:
      // eslint-disable-next-line max-len
      `api/integrations/028142ca/games?producer=${getSoftgamingFilterProviders()}&page_size=5000`,
    converter: GameCatalogConverterClass,
    sessionUrlData: {
      url: 'api/integrations/028142ca/login',
      // url: 'api/v1/session/url/auth',
      method: QueryTypes.POST,
      getBody: params => ({
        is_mobile: +!params.isDesktop,
        system: params.gameList.find((t: ISlotViewItem) => t.gameId === params.gameId)?.additionalData?.system,
        page_code: getPureGameId(params.gameId),

        auth_type: 'html',
      }),
      converter: data => GameCatalogConverterClass.convertGameUrl(data),
    },
  },

  [Providers.DIRECT_PRAGMATIC]: {
    gameListUrl:
      // eslint-disable-next-line max-len
      'api/integrations/08f21347/games?page_size=1000',
    converter: GameCatalogConverterClass,
    sessionUrlData: {
      url: 'api/integrations/08f21347/login',
      method: QueryTypes.POST,
      getBody: params => ({
        symbol: getPureGameId(params.gameId),
        platform: params.isDesktop ? 'WEB' : 'MOBILE',
        play_mode: params.mode,
        lobby_url: `${location.origin}${ROUTE_URLS.SLOTS('casino')}`,
      }),
      converter: GameCatalogConverterClass.convertGameUrlPragmatic,
    },
  },
}

// В default list не забывать задавать поле isDefault, щобы не дублировалось
